import request from '../api-request';
import { Permission } from 'manage-settings/manage-users/manage-users.types';

export function getPermissions() {
  return request<Permission[]>(`/api/permissions`);
}
